import { getPlatformEmailPattern } from "../../../../config/platformEmailPattern.js";
import { extractEmailDomain, getEnvEmailDomainConfigs, normalizeEmailDomain, resolveCustomerEnv } from "./emailAndEnvUtils.js";
import { LOGIN_EMAIL_REGEX } from "./constants.js";

/**
 * Pure: resolved customer/login match for a given email field value (no React).
 */
export function computeMatchedCustomerDataForEmail(emailValue, { isAdminAccess, customerKey, fetchedCustomerData }) {
  const trimmedEmail = emailValue?.trim();
  const normalizedEmail = String(trimmedEmail || "").toLowerCase();
  const isValidEmailFormat = trimmedEmail && LOGIN_EMAIL_REGEX.test(trimmedEmail);

  if (!trimmedEmail || !isValidEmailFormat) {
    if (
      !isAdminAccess
      && customerKey
      && fetchedCustomerData?.slug
      && String(fetchedCustomerData.slug).toLowerCase() === String(customerKey).toLowerCase()
    ) {
      return { ...fetchedCustomerData, matchSource: "url" };
    }
    return null;
  }

  const platformPattern = getPlatformEmailPattern();
  const normalizedPlatformPattern = normalizeEmailDomain(platformPattern);
  const emailMatchesPlatform = normalizedPlatformPattern && normalizedEmail.endsWith(normalizedPlatformPattern);

  if (isAdminAccess) {
    if (emailMatchesPlatform) {
      return {
        id: "onedoor",
        name: "One Door",
        slug: "onedoor",
        type: "internal",
        emailDomain: platformPattern,
      };
    }
    return null;
  }

  if (emailMatchesPlatform && fetchedCustomerData) {
    return {
      ...fetchedCustomerData,
      emailDomain: platformPattern,
      matchSource: "fallback",
      displayName: fetchedCustomerData.name,
    };
  }
  if (emailMatchesPlatform) {
    return null;
  }

  if (!fetchedCustomerData) {
    return null;
  }

  const emailDomain = extractEmailDomain(trimmedEmail);
  const currentEnv = resolveCustomerEnv(fetchedCustomerData);
  const envConfigs = getEnvEmailDomainConfigs(fetchedCustomerData, currentEnv);
  const matchingConfig = envConfigs.find((config) => {
    const ed = config.email_domain;
    if (ed == null || String(ed).trim() === "") return true;
    return normalizeEmailDomain(ed) === emailDomain;
  });

  if (matchingConfig) {
    return {
      ...fetchedCustomerData,
      emailDomain: emailDomain,
      idpType: matchingConfig.idp_type,
      idpDisplayName: matchingConfig.idp_display_name,
      matchSource: "domain",
      displayName: fetchedCustomerData.name,
    };
  }

  return null;
}
